/*
 * Schenk Socken – Filter für Größe, Farbe und Paketgröße auf der Kategorieseite.
 *
 * Shopify liefert Größen-/Farbfilter nur über die App „Search & Discovery“. Solange
 * die nicht eingerichtet ist, filtert dieses Skript die schon geladenen Produktkarten.
 * Jede Karte trägt ihre Varianten in data-ss-v (siehe snippets/ss-product-card.liquid):
 *   [{"g":"43-46","f":"Grau|Schwarz|","p":"6"}, …]   g = Größe, f = Farbfamilien, p = Paare
 *
 * Ein Produkt bleibt sichtbar, wenn mindestens EINE Variante alle gewählten Werte erfüllt
 * (Größe 43–46 und Schwarz heißt: es gibt Größe 43–46 in Schwarz).
 */
(() => {
  const box = document.getElementById('ss-facets');
  const grid = document.querySelector('.ss-collection .ss-grid');
  if (!box || !grid) return;

  const cards = [...grid.querySelectorAll('.ss-card[data-ss-v]')];
  if (!cards.length) return;

  cards.forEach((card) => {
    try {
      card._v = JSON.parse(card.dataset.ssV).map((v) => ({
        g: v.g,
        f: v.f.split('|').filter(Boolean),
        p: v.p,
      }));
    } catch (e) {
      card._v = [];
    }
  });

  const FARB_REIHENFOLGE = ['Schwarz', 'Grau', 'Blau', 'Beige', 'Weiß', 'Grün', 'Mehrfarbig'];
  const FARBEN = {
    Schwarz: '#1d1c1c',
    Grau: '#9a9a9a',
    Blau: '#3b5f9e',
    Beige: '#d8c7a8',
    Weiß: '#ffffff',
    Grün: '#5b6b3a',
    Mehrfarbig: 'linear-gradient(90deg,#3b5f9e 33%,#9a9a9a 33% 66%,#d8c7a8 66%)',
  };

  const GRUPPEN = [
    { key: 'g', titel: 'Größe', art: 'pill', mehrere: false, label: (v) => v.replace('-', '–') },
    { key: 'f', titel: 'Farbe', art: 'check', mehrere: true, label: (v) => v },
    { key: 'p', titel: 'Paketgröße', art: 'pill', mehrere: false, label: (v) => v + ' Paar' },
  ];

  // Werte je Gruppe einsammeln
  const werte = { g: new Set(), f: new Set(), p: new Set() };
  cards.forEach((c) =>
    c._v.forEach((v) => {
      if (v.g) werte.g.add(v.g);
      v.f.forEach((x) => werte.f.add(x));
      if (v.p) werte.p.add(v.p);
    })
  );
  const zahl = (s) => parseInt(String(s).split('-')[0], 10) || 0;
  const sortiert = {
    g: [...werte.g].sort((a, b) => zahl(a) - zahl(b)),
    p: [...werte.p].sort((a, b) => zahl(a) - zahl(b)),
    f: [...werte.f].sort((a, b) => {
      const ia = FARB_REIHENFOLGE.indexOf(a);
      const ib = FARB_REIHENFOLGE.indexOf(b);
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    }),
  };

  // Eine Gruppe mit nur einem Wert filtert nichts und wird nicht angezeigt
  const aktiveGruppen = GRUPPEN.filter((g) => sortiert[g.key].length > 1);
  if (!aktiveGruppen.length) return;

  const auswahl = { g: new Set(), f: new Set(), p: new Set() };

  // Auswahl aus der Adresse wiederherstellen (#g=43-46&f=Schwarz)
  try {
    new URLSearchParams(location.hash.slice(1)).forEach((val, key) => {
      if (auswahl[key] && sortiert[key].includes(val)) auswahl[key].add(val);
    });
  } catch (e) {
    /* ohne Vorauswahl weiter */
  }

  const passt = (card, sel) =>
    card._v.some((v) =>
      GRUPPEN.every((g) => {
        const s = sel[g.key];
        if (!s.size) return true;
        return g.key === 'f' ? v.f.some((x) => s.has(x)) : s.has(v[g.key]);
      })
    );

  // ---------- Aufbau ----------
  const el = (tag, attrs = {}, ...kinder) => {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') n.className = v;
      else if (k === 'style') n.style.cssText = v;
      else n.setAttribute(k, v);
    });
    kinder.forEach((k) => n.append(k));
    return n;
  };

  const eingaben = []; // { gruppe, wert, input, label, zaehler }

  aktiveGruppen.forEach((g, i) => {
    const details = el('details', i < 3 ? { open: '' } : {});
    details.append(el('summary', {}, g.titel));
    const inhalt = el('div', { class: g.art === 'pill' ? 'ss-sizebtns' : 'ss-facet-list' });
    sortiert[g.key].forEach((wert) => {
      const input = el('input', { type: 'checkbox', value: wert, 'data-facet': g.key });
      if (auswahl[g.key].has(wert)) input.checked = true;
      let label;
      let zaehler = null;
      if (g.art === 'pill') {
        input.className = 'ss-sr-only';
        label = el('label', { class: 'ss-pill' }, input, g.label(wert));
      } else {
        zaehler = el('span', { class: 'ss-check__count' });
        label = el(
          'label',
          { class: 'ss-check' },
          input,
          el('span', { class: 'ss-dot', style: 'background:' + (FARBEN[wert] || '#ccc') }),
          el('span', {}, g.label(wert), ' '),
          zaehler
        );
      }
      inhalt.append(label);
      eingaben.push({ gruppe: g, wert, input, label, zaehler });
      input.addEventListener('change', () => {
        const s = auswahl[g.key];
        if (input.checked) {
          if (!g.mehrere) s.clear();
          s.add(wert);
        } else {
          s.delete(wert);
        }
        aktualisieren();
      });
    });
    details.append(inhalt);
    box.append(details);
  });

  const zuruecksetzen = el('button', { type: 'button', class: 'ss-link-arrow ss-facets__reset', hidden: '' }, 'Auswahl zurücksetzen');
  zuruecksetzen.addEventListener('click', () => {
    Object.values(auswahl).forEach((s) => s.clear());
    aktualisieren();
  });
  box.append(zuruecksetzen);

  const leer = el(
    'p',
    { class: 'ss-empty', hidden: '' },
    'Für diese Auswahl gibt es keine Produkte. ',
    (() => {
      const b = el('button', { type: 'button', class: 'ss-link-arrow' }, 'Auswahl zurücksetzen');
      b.addEventListener('click', () => zuruecksetzen.click());
      return b;
    })()
  );
  grid.after(leer);

  const zaehlText = document.querySelector('.ss-collection .ss-count');
  const gesamtText = zaehlText ? zaehlText.textContent : '';

  // ---------- Aktualisieren ----------
  function aktualisieren() {
    // Produkte ein-/ausblenden
    let sichtbar = 0;
    cards.forEach((c) => {
      const ok = passt(c, auswahl);
      c.hidden = !ok;
      if (ok) sichtbar++;
    });

    // Zähler je Wert: wie viele Produkte blieben, wenn nur DIESER Wert in seiner Gruppe gewählt wäre
    eingaben.forEach((e) => {
      const key = e.gruppe.key;
      const probe = { g: new Set(auswahl.g), f: new Set(auswahl.f), p: new Set(auswahl.p) };
      probe[key] = new Set([e.wert]);
      const n = cards.filter((c) => passt(c, probe)).length;
      e.input.checked = auswahl[key].has(e.wert);
      const gesperrt = n === 0 && !e.input.checked;
      e.input.disabled = gesperrt;
      e.label.classList.toggle('is-disabled', gesperrt);
      if (e.zaehler) e.zaehler.textContent = '(' + n + ')';
    });

    const aktiv = Object.values(auswahl).some((s) => s.size);
    zuruecksetzen.hidden = !aktiv;
    leer.hidden = sichtbar > 0;
    if (zaehlText) {
      zaehlText.textContent = aktiv
        ? sichtbar + ' von ' + cards.length + ' Produkten'
        : gesamtText;
    }

    // Auswahl in der Adresse merken, ohne die Seite neu zu laden
    const p = new URLSearchParams();
    Object.entries(auswahl).forEach(([k, s]) => s.forEach((v) => p.append(k, v)));
    try {
      history.replaceState(null, '', location.pathname + location.search + (p.toString() ? '#' + p : ''));
    } catch (e) {
      /* Adresse bleibt unverändert */
    }
  }

  box.hidden = false;
  aktualisieren();
})();
